

import { baseUrl_SPB} from '../BaseUrl';
export default async function RetrieveCompanyList(token) {
    try {
        const response = await fetch(`${baseUrl_SPB}/api/v1/company/companylist`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        });
        if (!response.ok) throw new Error('Failed to fetch company list');
        return response.json();
    } catch (error) {
        console.error('Error:', error);
        return [];
    }
}

